import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { AppProvider, useApp } from "@/lib/AppContext";
import Login from "@/pages/Login";
import Portal from "@/pages/Portal";
import LinkRedirect from "@/pages/LinkRedirect";

function Protected({ children }) {
  const { user, loadingAuth } = useApp();
  if (loadingAuth) {
    return (
      <div className="min-h-screen grid place-items-center">
        <div className="w-10 h-10 rounded-full border-2 border-[#d4a843]/40 border-t-[#f3c669] animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function PublicOnly({ children }) {
  const { user, loadingAuth } = useApp();
  if (loadingAuth) return null;
  if (user) return <Navigate to="/" replace />;
  return children;
}

export default function App() {
  return (
    <div className="App">
      <AppProvider>
        <BrowserRouter>
          <Toaster
            position="top-right"
            richColors
            theme="dark"
            toastOptions={{
              style: {
                background: "#132744",
                border: "1px solid #1e3a61",
                color: "#f8fafc",
              },
            }}
          />
          <Routes>
            <Route path="/l/:code/:slug" element={<LinkRedirect />} />
            <Route
              path="/login"
              element={
                <PublicOnly>
                  <Login />
                </PublicOnly>
              }
            />
            <Route
              path="/"
              element={
                <Protected>
                  <Portal />
                </Protected>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AppProvider>
    </div>
  );
}
